var CartDrawer = {

  // Limite d'unités par référence pour les produits d'entretien (KLEAN/EPI/OUTIL).
  MAX_ENTRETIEN: 50,

  // Un type produit est « entretien » si son code contient KLEAN/EPI/OUTIL
  // (codes stables dans toutes les langues, cf. cart-drawer.liquid).
  _isEntretienType: function (type) {
    var t = String(type || '').toUpperCase();
    return t.indexOf('KLEAN') >= 0 || t.indexOf('EPI') >= 0 || t.indexOf('OUTIL') >= 0;
  },

  open: function () {
    document.getElementById('drawer').classList.add('open');
    document.getElementById('overlay').classList.add('open');
    document.body.style.overflow = 'hidden';
  },

  close: function () {
    document.getElementById('drawer').classList.remove('open');
    document.getElementById('overlay').classList.remove('open');
    document.body.style.overflow = '';
  },

  changeQty: function (key, newQty) {
    // Min par produit : 5 m² pour une moquette, 1 pour un produit simple.
    var row = document.getElementById('ci-' + key);
    var min = row ? (parseInt(row.getAttribute('data-min')) || 1) : 1;
    if (newQty < min) newQty = min;
    // Produit d'entretien : plafond de 50 unités par référence.
    if (row && row.getAttribute('data-entretien') === '1' && newQty > CartDrawer.MAX_ENTRETIEN) {
      newQty = CartDrawer.MAX_ENTRETIEN;
      var I = window.ORAK_I18N || {};
      CartDrawer.toast(I.maxEntretien || 'Maximum 50 par référence.');
    }
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { CartDrawer.refresh(cart); });
  },

  removeItem: function (key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { CartDrawer.refresh(cart); });
  },

  addItem: function (variantId, qty, properties) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: qty || 5, properties: properties || {} }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        return CartDrawer._clampEntretien(cart);
      })
      .then(function (cart) {
        CartDrawer.refresh(cart);
        CartDrawer.open();
        CartDrawer.bump();
      });
  },

  // Ramène à 50 toute ligne d'entretien qui dépasserait le plafond après un
  // ajout au panier. Renvoie une promesse résolue avec le panier à jour.
  _clampEntretien: function (cart) {
    var over = (cart.items || []).filter(function (it) {
      return CartDrawer._isEntretienType(it.product_type) && it.quantity > CartDrawer.MAX_ENTRETIEN;
    });
    if (!over.length) return Promise.resolve(cart);
    var I = window.ORAK_I18N || {};
    CartDrawer.toast(I.maxEntretien || 'Maximum 50 par référence.');
    return over.reduce(function (chain, it) {
      return chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: it.key, quantity: CartDrawer.MAX_ENTRETIEN })
        }).then(function (r) { return r.json(); });
      });
    }, Promise.resolve()).then(function (finalCart) {
      return finalCart && finalCart.items ? finalCart : cart;
    });
  },

  refresh: function (cart) {
    return fetch((window.ORAK_ROOT || '') + '/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var newDrawer = tmp.querySelector('.drawer');
        var el = document.getElementById('drawer');
        if (newDrawer && el) el.innerHTML = newDrawer.innerHTML;
        CartDrawer.updateCount(CartDrawer._distinctCount(cart));
        CartDrawer.updateShipBar(cart.total_price);
      });
  },

  // Nombre de produits DISTINCTS (par product_id) plutôt que la quantité totale.
  _distinctCount: function (cart) {
    var ids = {};
    (cart.items || []).forEach(function (it) { ids[it.product_id] = 1; });
    return Object.keys(ids).length;
  },

  updateCount: function (count) {
    document.querySelectorAll('#navBadge, #dBadge, .cart-badge').forEach(function (el) {
      el.textContent = count;
    });
    // Masquer le badge si 0
    document.querySelectorAll('#navBadge').forEach(function (el) {
      el.style.display = count > 0 ? '' : 'none';
    });
  },

  updateShipBar: function (totalPrice) {
    var FREE_SHIP = 200000;
    // La barre 2 000 € ne compte que la moquette : montant fourni par la section.
    var bar = document.getElementById('dShip');
    if (bar && bar.dataset.base != null && bar.dataset.base !== '') totalPrice = Number(bar.dataset.base) || 0;
    var pct = Math.min(totalPrice / FREE_SHIP * 100, 100);
    var fill = document.getElementById('dShipFill');
    if (fill) fill.style.width = pct.toFixed(0) + '%';
    var pctEl = document.getElementById('dShipPct');
    if (pctEl) pctEl.textContent = pct.toFixed(0) + '%';
  },

  bump: function () {
    var badge = document.getElementById('navBadge');
    if (!badge) return;
    badge.classList.remove('bump');
    void badge.offsetWidth; // reflow
    badge.classList.add('bump');
    setTimeout(function () { badge.classList.remove('bump'); }, 300);
  },

  toast: function (msg) {
    var el = document.getElementById('orakToast');
    if (!el) return;
    el.querySelector('.toast-msg').textContent = msg;
    el.classList.add('show');
    setTimeout(function () { el.classList.remove('show'); }, 2800);
  },

  /* ─── Étape 2 : porte connexion / pro / validation (2ᵉ page) ──── */

  toShipping: function () {
    var pane = document.getElementById('drawerShip');
    if (!pane) return;
    pane.classList.add('open');
    CartDrawer._gate();
  },

  toCart: function () {
    var pane = document.getElementById('drawerShip');
    if (pane) pane.classList.remove('open');
  },

  // Affiche un seul écran d'état (A / B / B-mixte / C ou chargement).
  _gateShow: function (stateId) {
    ['cgLoading', 'cgStateA', 'cgStateB', 'cgStateBMix', 'cgStateC'].forEach(function (s) {
      var el = document.getElementById(s); if (el) el.hidden = (s !== stateId);
    });
    // Le bouton secondaire n'existe qu'en état mixte : masqué partout ailleurs.
    if (stateId !== 'cgStateBMix') CartDrawer._gateAlt(false);
  },

  // Affiche/masque le bouton secondaire « commander sans l'entretien ».
  _gateAlt: function (show) {
    var alt = document.getElementById('cgCtaAlt');
    if (!alt) return;
    alt.hidden = !show;
    if (show) alt.disabled = false;
  },

  // Configure le bouton UNIQUE #cgCta (libellé, icône, action). opts=null → masqué.
  _gateCta: function (opts) {
    var cta = document.getElementById('cgCta');
    var lbl = document.getElementById('cgCtaLbl');
    var ico = document.getElementById('cgCtaIco');
    if (!cta) return;
    if (!opts) { cta.hidden = true; CartDrawer._mode = null; CartDrawer._modeUrl = null; return; }
    cta.hidden = false;
    cta.disabled = false;
    if (lbl) lbl.textContent = opts.label || '';
    if (ico) ico.className = 'ti ' + (opts.icon || '');
    CartDrawer._mode = opts.mode || null;
    CartDrawer._modeUrl = opts.url || null;
  },

  _loginUrl: function () {
    var loc = window.ORAK_ROOT || '';
    return loc + '/pages/connexion?return_to=' + encodeURIComponent(loc + '/cart');
  },

  // Détermine l'état du client et affiche l'écran + configure le bouton unique.
  _gate: function () {
    var I = window.ORAK_I18N || {};
    var loc = window.ORAK_ROOT || '';
    var token = null;
    try { token = localStorage.getItem('orak_session'); } catch (e) {}
    var appUrl = window.ORAK_APP_URL || '';
    var err = document.getElementById('cgError'); if (err) err.hidden = true;

    // Non connecté → écran A + bouton « se connecter » (synchrone).
    if (!token || !appUrl) {
      CartDrawer._gateShow('cgStateA');
      CartDrawer._gateCta({ mode: 'login', label: I.login, icon: 'ti-user', url: CartDrawer._loginUrl() });
      return;
    }

    // Connecté → on charge le profil (statut pro + préremplissage).
    CartDrawer._gateShow('cgLoading');
    CartDrawer._gateCta(null);
    fetch(appUrl + '/auth/me', { headers: { 'Authorization': 'Bearer ' + token } })
      .then(function (r) { if (!r.ok) throw new Error('auth'); return r.json(); })
      .then(function (d) {
        var c = (d && d.customer) || {};
        var co = c.company || {};
        CartDrawer._profile = { customer: c, company: co };

        var isPro = !!(String(co.siret || '').trim() || String(co.vat || '').trim());
        var hasEntretien = !!document.querySelector('#dItems .ci[data-entretien="1"]');

        // Particulier + produit d'entretien → blocage pro.
        if (hasEntretien && !isPro) {
          var hasOpen = !!document.querySelector('#dItems .ci[data-entretien="0"]');
          var proUrl = loc + '/pages/espace-client';
          if (hasOpen) {
            // Panier mixte : entretien (pro) + moquette/échantillon (ouvert à tous).
            // On garde le CTA pro (panier complet), + une sortie « sans l'entretien ».
            CartDrawer._buildProList();
            CartDrawer._gateShow('cgStateBMix');
            CartDrawer._gateCta({ mode: 'pro', label: I.pro, icon: 'ti-briefcase', url: proUrl });
            CartDrawer._gateAlt(true);
          } else {
            // Panier 100 % entretien : blocage complet (écran B inchangé).
            CartDrawer._gateShow('cgStateB');
            CartDrawer._gateCta({ mode: 'pro', label: I.pro, icon: 'ti-briefcase', url: proUrl });
          }
          return;
        }

        // Autorisé → écran C « Vous êtes connecté » + récap + bouton commander.
        var name = [c.first_name, c.last_name].filter(Boolean).join(' ').trim();
        var recap = document.getElementById('cgRecap');
        if (recap) {
          recap.innerHTML = '';
          var lines = [];
          if (name) lines.push(name);
          if (co.name) lines.push(co.name);
          var addr = [co.billing_address1, co.billing_zip, co.billing_city].filter(Boolean).join(', ');
          if (addr) lines.push(addr);
          if (c.email) lines.push(c.email);
          lines.forEach(function (t) {
            var row = document.createElement('div');
            row.className = 'cg-recap-line';
            row.textContent = t;
            recap.appendChild(row);
          });
        }
        CartDrawer._gateShow('cgStateC');
        CartDrawer._gateCta({ mode: 'checkout', label: I.proceed, icon: 'ti-lock' });
      })
      .catch(function () {
        // Token invalide / expiré → traiter comme non connecté.
        try { localStorage.removeItem('orak_session'); } catch (e) {}
        CartDrawer._gateShow('cgStateA');
        CartDrawer._gateCta({ mode: 'login', label: I.login, icon: 'ti-user', url: CartDrawer._loginUrl() });
      });
  },

  // Aiguille le clic du bouton unique selon l'état courant.
  gateAction: function () {
    var m = CartDrawer._mode;
    if (m === 'login' || m === 'pro') { if (CartDrawer._modeUrl) window.location.href = CartDrawer._modeUrl; return; }
    if (m === 'checkout') { CartDrawer.checkout(); return; }
  },

  // Pousse email + adresse du profil dans un panier Storefront puis redirige
  // vers le checkout hébergé (pré-rempli via buyerIdentity).
  checkout: function () {
    var prof = CartDrawer._profile;
    if (!prof) { CartDrawer._gate(); return; }
    var I = window.ORAK_I18N || {};
    var cta = document.getElementById('cgCta');
    var lbl = document.getElementById('cgCtaLbl');
    var err = document.getElementById('cgError');
    if (err) err.hidden = true;
    if (cta) cta.disabled = true;
    if (lbl) { lbl.dataset.o = lbl.textContent; lbl.textContent = I.loading || 'Redirection…'; }

    var domain = window.ORAK_SF_DOMAIN, sfToken = window.ORAK_SF_TOKEN;
    var c = prof.customer, co = prof.company;

    var fail = function () {
      if (cta) cta.disabled = false;
      if (lbl && lbl.dataset.o) lbl.textContent = lbl.dataset.o;
      if (err) { err.hidden = false; err.textContent = I.error || 'Une erreur est survenue. Merci de réessayer.'; }
    };

    // Remise client sur les moquettes (orak.discount_percent) : propriété cachée
    // _remise_pct sur les lignes de moquette, pour que le transport calcule le seuil
    // de 2 000 € HT sur ce que le client paie réellement. Sans remise, rien ne change.
    var remisePct = Math.round(Number(c.discount_percent) || 0);
    if (!(remisePct > 0 && remisePct < 100)) remisePct = 0;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lines = (cart.items || []).map(function (it) {
          var attrs = [];
          var props = it.properties || {};
          Object.keys(props).forEach(function (k) {
            if (k.charAt(0) === '_') return;
            var v = props[k];
            if (v == null || v === '') return;
            attrs.push({ key: String(k), value: String(v) });
          });
          var isMoquette = !CartDrawer._isEntretienType(it.product_type) && it.handle !== 'echantillon-de-moquette';
          if (remisePct && isMoquette) attrs.push({ key: '_remise_pct', value: String(remisePct) });
          return { merchandiseId: 'gid://shopify/ProductVariant/' + it.variant_id, quantity: it.quantity, attributes: attrs };
        });
        if (!lines.length) throw new Error('empty');

        var deliveryAddress = {
          firstName: c.first_name || '',
          lastName:  c.last_name || '',
          company:   co.name || '',
          address1:  co.billing_address1 || '',
          address2:  co.billing_address2 || '',
          city:      co.billing_city || '',
          zip:       co.billing_zip || '',
          country:   co.billing_country || 'France',
          phone:     co.billing_phone || c.phone || ''
        };
        var buyerIdentity = { email: c.email || '' };
        if (deliveryAddress.address1 && deliveryAddress.zip) {
          buyerIdentity.deliveryAddressPreferences = [{ deliveryAddress: deliveryAddress }];
        }

        var query = 'mutation cartCreate($input: CartInput!){cartCreate(input:$input){cart{id checkoutUrl} userErrors{field message}}}';
        return fetch('https://' + domain + '/api/2025-01/graphql.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': sfToken },
          body: JSON.stringify({ query: query, variables: { input: { lines: lines, buyerIdentity: buyerIdentity } } })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        var cc = res && res.data && res.data.cartCreate;
        var url = cc && cc.cart && cc.cart.checkoutUrl;
        if (!url) throw new Error('no-url');
        window.location.href = url;
      })
      .catch(fail);
  },

  /* ─── Panier mixte : retrait de l'entretien + annulation (undo) ──── */

  _esc: function (s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  },

  // Remplit la liste des produits réservés aux pros dans l'écran mixte,
  // à partir du DOM du panier (source de vérité : data-entretien="1").
  _buildProList: function () {
    var box = document.getElementById('cgProList');
    if (!box) return;
    box.innerHTML = '';
    document.querySelectorAll('#dItems .ci[data-entretien="1"]').forEach(function (row) {
      var name = ((row.querySelector('.ci-name') || {}).textContent || '').trim();
      var qty = ((row.querySelector('.ci-q-val') || {}).textContent || '').trim();
      var img = row.querySelector('.ci-thumb img');
      var thumb = img
        ? '<img class="cg-proitem-img" src="' + CartDrawer._esc(img.getAttribute('src')) + '" alt="" width="40" height="40">'
        : '<span class="cg-proitem-img cg-proitem-ph"><i class="ti ti-spray"></i></span>';
      var el = document.createElement('div');
      el.className = 'cg-proitem';
      el.innerHTML = thumb +
        '<span class="cg-proitem-name">' + CartDrawer._esc(name) + '</span>' +
        (qty ? '<span class="cg-proitem-qty">\u00d7' + CartDrawer._esc(qty) + '</span>' : '');
      box.appendChild(el);
    });
  },

  // Re-ouvre l'étape 2 sans animation (on y est déjà) puis réévalue la porte.
  _reopenGate: function () {
    var pane = document.getElementById('drawerShip');
    if (pane) {
      pane.style.transition = 'none';
      pane.classList.add('open');
      void pane.offsetWidth; // reflow
      pane.style.transition = '';
    }
    CartDrawer._gate();
  },

  // Retire toutes les lignes d'entretien puis rebascule sur l'écran validation
  // (état C) pour commander uniquement moquettes/échantillons. Réversible.
  checkoutWithoutEntretien: function () {
    var alt = document.getElementById('cgCtaAlt');
    if (alt) alt.disabled = true;
    var keys = [];
    document.querySelectorAll('#dItems .ci[data-entretien="1"]').forEach(function (row) {
      keys.push(row.id.replace('ci-', ''));
    });
    if (!keys.length) { CartDrawer._gate(); return; }

    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      // Mémoriser pour l'annulation : variante + quantité + propriétés.
      CartDrawer._undoItems = (cart.items || []).filter(function (it) {
        return keys.indexOf(it.key) >= 0;
      }).map(function (it) {
        return { id: it.variant_id, quantity: it.quantity, properties: it.properties || {} };
      });

      // Passer chaque ligne entretien à 0 (séquentiel).
      return keys.reduce(function (chain, key) {
        return chain.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          }).then(function (r) { return r.json(); });
        });
      }, Promise.resolve()).then(function (finalCart) {
        return CartDrawer.refresh(finalCart).then(function () {
          CartDrawer._reopenGate();
          CartDrawer._showUndo();
        });
      });
    }).catch(function () {
      if (alt) alt.disabled = false;
      var err = document.getElementById('cgError');
      var I = window.ORAK_I18N || {};
      if (err) { err.hidden = false; err.textContent = I.error || 'Une erreur est survenue. Merci de réessayer.'; }
    });
  },

  // Ré-ajoute les produits d'entretien retirés et revient à l'écran mixte.
  undoRemoveEntretien: function () {
    var items = CartDrawer._undoItems || [];
    CartDrawer._hideUndo();
    if (!items.length) return;
    CartDrawer._undoItems = null;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function () {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      return CartDrawer.refresh(cart).then(function () { CartDrawer._reopenGate(); });
    });
  },

  _showUndo: function () {
    var el = document.getElementById('orakUndo');
    if (!el) return;
    var I = window.ORAK_I18N || {};
    var msg = el.querySelector('.undo-msg');
    if (msg) msg.textContent = I.bmixRemoved || 'Produits d\u2019entretien retirés';
    var btn = el.querySelector('.undo-btn');
    if (btn) btn.textContent = I.bmixUndo || 'Annuler';
    el.classList.add('show');
    clearTimeout(CartDrawer._undoT);
    CartDrawer._undoT = setTimeout(function () {
      CartDrawer._hideUndo();
      CartDrawer._undoItems = null;
    }, 6000);
  },

  _hideUndo: function () {
    var el = document.getElementById('orakUndo');
    if (el) el.classList.remove('show');
    clearTimeout(CartDrawer._undoT);
  }
};

/* ─── Fermer avec Echap ──────────────────────────────────────── */
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') CartDrawer.close();
});

/* ─── Boutons "Ajouter au panier" (data-add-to-cart) ────────── */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-add-to-cart]');
  if (!btn) return;
  e.preventDefault();

  var variantId = btn.dataset.variantId;
  var qty = parseInt(btn.dataset.qty) || 5;
  var properties = {};

  // Lire les options depuis data-properties (JSON stringifié) si présent
  if (btn.dataset.properties) {
    try { properties = JSON.parse(btn.dataset.properties); } catch (err) {}
  }

  CartDrawer.addItem(variantId, qty, properties);
});

/* ─── Init : masquer le badge si panier vide ─────────────────── */
document.addEventListener('DOMContentLoaded', function () {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      CartDrawer.updateCount(CartDrawer._distinctCount(cart));
      CartDrawer.updateShipBar(cart.total_price);
    });
});
